import React from 'react';
import _ from 'lodash';
import { useParams } from "react-router-dom";
import './T001.scss';

import * as DataAPI from "./Common/DataAPI";
import constants from "./Common/constants";

const MESSAGES = constants.localeMessage;

class T001 extends React.Component {
  constructor(props) {
    super();

    const query = _.split(_.replace(_.get(window, 'location.search'), '?', ''), '&')

    let lang = 'zhTW';
    _.forEach(query, item => {
      if (_.startsWith(item, 'lang')) {
        lang = _.last(_.split(item, '='));
      }
    });

    this.state = {
      lang,
      deviceId: _.get(props.params, 'deviceId'),
      queueId: _.get(props.params, 'queueId'),
      myTicket: _.get(props.params, 'myTicket'),
      queue: null,
      device: null,
      shouldShowTicketPassed: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.getDevice();
    this.getQueue();
  }

  getDevice() {
    DataAPI.get(`${constants.queueStatusDomain}/api/public/device/${this.state.deviceId}`, {}, (err, device) => {
      if (err) return console.error('device error:', err);

      this.setState({
        device,
      });
    });
  }

  getQueue() {
    DataAPI.get(`${constants.queueStatusDomain}/api/public/queue/${this.state.queueId}`, {}, (err, queue) => {
      if (err) return console.error('queue error:', err);

      _.set(queue, 'lastNumberToShow', _.padStart(queue.lastNumber, queue.numberOfDigit, '0'));

      const myTicketNumber = _.toNumber(_.join(_.drop(_.split(this.state.myTicket, '')), ''));
      const shouldShowTicketPassed = queue.lastNumber > myTicketNumber;

      this.setState({
        queue,
        shouldShowTicketPassed,
      });
    });
  }

  render() {
    return (
      <div className="t001-block">
        <div className="logo-block">
          <img alt="logo" src={_.get(this.state.device, 'logo.url')} />
        </div>
        <div className="ticket-info">
          <div className="current-number-title">{MESSAGES.LAST_CALLED_NUMBER[this.state.lang]}</div>
          <div className="current-number">
            {_.get(this.state.queue, 'prefix', '') + _.get(this.state.queue, 'lastNumberToShow', '')}
          </div>
          <div className="line" />
          <div className="your-number-title">{MESSAGES.YOUR_NUMBER[this.state.lang]}</div>
          <div className="your-number">{this.state.myTicket}</div>
        </div>
        <img alt="ticket" className="ticket-img" src={'/ticket-001.png'} />
        {
          this.state.shouldShowTicketPassed &&
          <div className="ticket-passed-block">
            <div className="bg" />
            <div className="text">{MESSAGES.TICKET_PASSED[this.state.lang]}</div>
          </div>
        }
        <div className="footer-block">
          <div className="lang-block">
            <a className={(this.state.lang === 'zhTW' ? "active " : "") + "lang-btn chi"}
               href={window.location.origin + window.location.pathname}
               target="_self">中</a>
            <a className={(this.state.lang === 'en' ? "active " : "") + "lang-btn eng"}
               href={window.location.origin + window.location.pathname + '?lang=en'}
               target="_self">ENG</a>
          </div>
          <div className="outer-block">
            <div className="provided-by">Provided by</div>
            <img alt="LDS logo" src={'/logo-ld.png'} />
          </div>
        </div>
      </div>
    )
  }
}

const T001Params = (props) => (
  <T001
    {...props}
    params={useParams()}
  />
)

export default T001Params;
